module.exports = __webpack_public_path__ + "img/article-image-1.d24ba269.webp";